/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from "@emotion/styled";
import { ThemeMode } from "@smartsheet/sds-theme-internal";
import { blanketTheme } from "./blanketTheme";
declare type PointerEventsProperty = import("csstype").PointerEventsProperty;

export interface BlanketStyledProps {
    canClickThrough: boolean;
    isTinted: boolean;
    themeMode: ThemeMode;
    zIndex: number;
}

export const opacity = (p: BlanketStyledProps): number => (p.isTinted ? blanketTheme.opacity(p.themeMode) : 0);
export const pointerEvents: (p: BlanketStyledProps) => PointerEventsProperty = (p) =>
    p.canClickThrough ? "none" : "initial";

export const BlanketStyled = styled("div")<BlanketStyledProps>`
    background: ${({ themeMode }) => blanketTheme.background(themeMode)};
    bottom: 0;
    left: 0;
    opacity: ${opacity};
    pointer-events: ${pointerEvents};
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity 220ms;
    z-index: ${({ zIndex }) => zIndex};
`;
